import { useOrg } from "../../auth/org-provider";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

export function useProjectsOrgReadinessQuery() {
    const org = useOrg();
    return useQuery({
        queryKey: ["projects-org-readiness", org.id],
        queryFn: async () => {
            const res = await apiClient.getOrgReadiness();
            if (res.status !== 200) {
                throw new Error("failed to fetch org readiness");
            }
            return res.body.data;
        },
    });
}
